"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(theme) {
  return {
    root: {
      display: 'inline-flex',
      width: '100%',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.grey[300],
      padding: [[0, 0, 0, theme.spacing(1)]],
      flexDirection: 'row',
      flexWrap: 'nowrap',
      justifyContent: 'flex-start',
      alignItems: 'center',
      position: 'relative',
      boxShadow: 'none',
      transition: theme.transitions.create(['background-color', 'box-shadow'], {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.standard
      })
    },
    rootActive: {
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[2],
      color: theme.palette.grey[800]
    },
    searchIcon: {
      color: theme.palette.text.secondary
    },
    inputRoot: {
      width: '100%'
    },
    inputInput: {
      padding: theme.spacing(1),
      lineHeight: theme.spacing(3),
      color: theme.palette.grey[800],
      fontWeight: theme.typography.fontWeightBold,
      fontSize: theme.typography.subtitle2.fontSize,
      flexGrow: 0,
      '&::placeholder': {
        color: theme.palette.grey[800],
        opacity: 0.9
      }
    },
    iconButton: {
      padding: theme.spacing(1),
      color: theme.palette.text.secondary
    },
    searchButton: {
      flexShrink: 0,
      flexGrow: 0,
      alignSelf: 'stretch',
      borderRadius: 0,
      boxShadow: 'none',
      minWidth: 0,
      width: 0,
      paddingLeft: 0,
      paddingRight: 0,
      transition: theme.transitions.create('all', {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.standard
      })
    },
    searchButtonUnappliedChanges: _defineProperty({
      width: theme.spacing(11),
      paddingLeft: theme.spacing(2),
      marginLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }, theme.breakpoints.down('sm'), {
      width: theme.spacing(5),
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1)
    }),
    searchButtonIcon: {
      verticalAlign: 'middle'
    },
    searchButtonLabel: {
      flexGrow: 1,
      flexShrink: 1,
      display: 'block',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    clearButton: {
      marginRight: -theme.spacing(1) * 1.5
    },
    menuButton: {},
    searchFacet: {},
    searchFacets: {},
    menu: {
      position: 'absolute',
      top: 'calc(100% - 2px)',
      left: 0,
      right: 0,
      zIndex: theme.zIndex.modal,
      borderRadius: 0
    }
  };
};

var _default = (0, _withStyles["default"])(styles);

exports["default"] = _default;